// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EmailPassword {
    color: white;
    width: 100%;
    max-width: 100%;
}

.emailPasswordContainer {
    display: flex;
    flex-direction: column;
    align-items: start;
    gap: 2px;
    width: 100%;
    max-width: 100%;
}

/* General Input Container Styles */
.generalInputContainer {
    display: flex;
    flex-direction: column;
    align-items: start;
    gap: 8px;
    width: 100%;
    margin-bottom: 20px;
}

.labelText {
    font-family: "Inter", sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
    color: white;
}

.inputContainerWrapper {
    position: relative;
    background-color: #1a1a1a;
    width: 31.51vw;
    height: 4.8vh;
    border-radius: 52px;
    box-sizing: border-box;
    padding-left: 16px;
    padding-right: 50px;
    font-family: "Inter", sans-serif;
    font-size: 16px;
    font-weight: 500;
    display: flex;
    align-items: center;
}

.input {
    all: unset;
    width: 100%;
    height: 100%;
    color: white;
    font-family: "Inter", sans-serif;
    font-size: 16px;
    font-weight: 500;
}

.input::placeholder {
    color: #7A7A7A;
    opacity: 1;
}

/* Eye icon for password visibility toggle */
.eyeIcon {
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    color: #7A7A7A;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    transition: color 0.2s ease;
    z-index: 10;
}

.eyeIcon:hover {
    color: #00c9a7;
}

.eyeIcon svg {
    width: 20px;
    height: 20px;
}

/* Error tooltip styles */
.errorTooltip {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    padding: 6px 12px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 400;
    margin-top: 4px;
    display: flex;
    align-items: center;
    gap: 8px;
    transition: all 0.3s ease;
    z-index: 10;
    background: #ff4444;
    color: white;
    font-family: "Inter", sans-serif;
}

/* Checkbox container styles */
.checkboxContainer {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    margin-top: 20px;
    width: 100%;
}

.checkboxContainer input[type="checkbox"] {
    appearance: none;
    -webkit-appearance: none;
    width: 18px;
    height: 18px;
    border: 2px solid #ccc;
    border-radius: 4px;
    cursor: pointer;
    position: relative;
    transition: all 0.2s ease;
    flex-shrink: 0;
    margin-top: 2px;
}

.checkboxContainer input[type="checkbox"]:checked {
    background-color: #00c9a7;
    border-color: #00c9a7;
}

.checkboxContainer input[type="checkbox"]:checked::after {
    content: "✓";
    position: absolute;
    color: white;
    font-size: 14px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.checkboxLabel {
    font-family: "Inter", sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    cursor: pointer;
    flex: 1 1;
    color: white;
}

.irregularText {
    color: #00c9a7;
    cursor: pointer;
    text-decoration: underline;
}

/* Button styles */
.btnContainer {
    all: unset;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 31.51vw;
    height: 4.8vh;
    background-color: #48d1cc;
    border-radius: 30px;
    margin-top: 28px;
    cursor: pointer;
    transition: all 0.3s ease;
    font-family: "Inter", sans-serif;
}

.btnContainer:active {
    transform: translateY(0);
}

.btnContainer:disabled {
    background-color: #666;
    cursor: not-allowed;
    transform: none;
}

.btnText {
    all: unset;
    font-family: "Inter", sans-serif;
    font-size: 16px;
    line-height: 24px;
    font-weight: 500;
    color: white;
}

/* Tablet and small desktop adjustments */
@media (max-width: 1640px) {
    .checkboxLabel {
        font-size: 14px;
    }
    .checkboxContainer input[type="checkbox"] {
        width: 16px;
        height: 16px;
    }
    .labelText {
        font-size: 13px;
    }
    .input {
        font-size: 15px;
    }
}

@media (max-width: 1440px) {
    .checkboxLabel {
        font-size: 12px;
    }
    .checkboxContainer input[type="checkbox"] {
        width: 14px;
        height: 14px;
    }
    .labelText {
        font-size: 12px;
    }
    .input {
        font-size: 14px;
    }
}

@media (max-width: 1280px) {
    .checkboxLabel {
        font-size: 10px;
    }
    .checkboxContainer input[type="checkbox"] {
        width: 12px;
        height: 12px;
        border-radius: 3px;
    }
    .labelText {
        font-size: 11px;
    }
    .input {
        font-size: 13px;
    }
}

@media (max-width: 1024px) {
    .checkboxLabel {
        font-size: 8px;
    }
    .checkboxContainer input[type="checkbox"] {
        width: 10px;
        height: 10px;
        border-radius: 3px;
    }
    .labelText {
        font-size: 10px;
    }
    .input {
        font-size: 12px;
    }
}

/* Mobile responsive styles */
@media (max-width: 768px) {
    .emailPasswordContainer {
        gap: 8px;
        padding: 0 16px 0 16px;
    }
    
    .generalInputContainer {
        margin-bottom: 16px;
    }
    
    .inputContainerWrapper {
        width: 100% !important;
        height: 52px;
        border-radius: 14px;
        padding-left: 16px;
        padding-right: 50px;
    }
    
    .input {
        font-size: 16px;
    }
    
    .labelText {
        font-size: 14px;
        font-weight: 500;
    }
    
    .eyeIcon {
        right: 16px;
        top: 50%;
        transform: translateY(-50%);
        width: 24px;
        height: 24px;
    }
    
    .eyeIcon svg {
        width: 22px;
        height: 22px;
    }
    
    .checkboxContainer {
        margin-top: 16px;
        gap: 12px;
        align-items: flex-start;
    }
    
    .checkboxContainer input[type="checkbox"] {
        width: 20px;
        height: 20px;
        border-radius: 4px;
        margin-top: 0;
    }
    
    .checkboxContainer input[type="checkbox"]:checked::after {
        font-size: 16px;
    }
    
    .checkboxLabel {
        font-size: 14px;
        line-height: 20px;
        flex: 1 1;
    }
    
    .irregularText {
        font-size: 14px;
    }
    
    .btnContainer {
        width: calc(100% - 32px) !important;
        height: 52px;
        border-radius: 14px;
        margin-top: 24px;
        font-size: 16px;
        background: linear-gradient(135deg, #48d1cc 0%, #3bb5a8 100%);
        box-shadow: 0 8px 20px rgba(59, 181, 168, 0.25);
        margin-left: auto;
        margin-right: auto;
    }
    
    .btnText {
        font-size: 16px;
        font-weight: 600;
    }
    
    .errorTooltip {
        font-size: 11px;
        padding: 4px 8px;
    }
}

@media (max-width: 480px) {
    .emailPasswordContainer {
        gap: 8px;
        padding: 0 12px 0 12px;
    }
    
    .generalInputContainer {
        margin-bottom: 14px;
    }
    
    .inputContainerWrapper {
        height: 48px;
        border-radius: 12px;
        padding-left: 14px;
        padding-right: 45px;
    }
    
    .input {
        font-size: 15px;
    }
    
    .labelText {
        font-size: 13px;
    }
    
    .eyeIcon {
        right: 14px;
        top: 50%;
        transform: translateY(-50%);
        width: 20px;
        height: 20px;
    }
    
    .eyeIcon svg {
        width: 20px;
        height: 20px;
    }
    
    .checkboxContainer {
        margin-top: 14px;
        gap: 10px;
    }
    
    .checkboxContainer input[type="checkbox"] {
        width: 18px;
        height: 18px;
    }
    
    .checkboxContainer input[type="checkbox"]:checked::after {
        font-size: 14px;
    }
    
    .checkboxLabel {
        font-size: 13px;
        line-height: 18px;
    }
    
    .irregularText {
        font-size: 13px;
    }
    
    .btnContainer {
        height: 48px;
        border-radius: 12px;
        margin-top: 20px;
        width: calc(100% - 24px) !important;
        margin-left: auto;
        margin-right: auto;
    }
    
    .btnText {
        font-size: 15px;
        font-weight: 600;
    }
    
    .errorTooltip {
        font-size: 10px;
        padding: 3px 6px;
    }
}

@media (max-width: 360px) {
    .emailPasswordContainer {
        padding: 0 8px 0 8px;
    }
    
    .generalInputContainer {
        margin-bottom: 12px;
    }
    
    .inputContainerWrapper {
        height: 44px;
        border-radius: 10px;
        padding-left: 12px;
        padding-right: 40px;
    }
    
    .input {
        font-size: 14px;
    }
    
    .labelText {
        font-size: 12px;
    }
    
    .eyeIcon {
        right: 12px;
        top: 50%;
        transform: translateY(-50%);
        width: 18px;
        height: 18px;
    }
    
    .eyeIcon svg {
        width: 18px;
        height: 18px;
    }
    
    .checkboxContainer {
        gap: 8px;
        margin-top: 12px;
    }
    
    .checkboxContainer input[type="checkbox"] {
        width: 16px;
        height: 16px;
    }
    
    .checkboxContainer input[type="checkbox"]:checked::after {
        font-size: 12px;
    }
    
    .checkboxLabel {
        font-size: 12px;
        line-height: 16px;
    }
    
    .irregularText {
        font-size: 12px;
    }
    
    .btnContainer {
        height: 44px;
        border-radius: 10px;
        margin-top: 16px;
        width: calc(100% - 16px) !important;
        margin-left: auto;
        margin-right: auto;
    }
    
    .btnText {
        font-size: 14px;
        font-weight: 600;
    }
    
    .errorTooltip {
        font-size: 9px;
        padding: 2px 4px;
    }
}

/* Focus states for better accessibility */
.input:focus {
    outline: none;
}

.inputContainerWrapper:focus-within {
    box-shadow: 0 0 0 2px rgba(72, 209, 204, 0.3);
}

/* Loading state for referral code validation */
.inputContainerWrapper .loader {
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
    width: 20px;
    height: 20px;
}

/* Success state for valid inputs */
.inputContainerWrapper.valid {
    border: 1px solid #00c9a7;
}

.inputContainerWrapper.error {
    border: 1px solid #ff4444;
}
`, "",{"version":3,"sources":["webpack://./src/Components/SignUpFlow/EmailPassword/EmailPassword.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,eAAe;AACnB;;AAEA,mCAAmC;AACnC;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,gCAAgC;IAChC,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,UAAU;AACd;;AAEA,4CAA4C;AAC5C;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA,yBAAyB;AACzB;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,yBAAyB;IACzB,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ,gCAAgC;AACpC;;AAEA,8BAA8B;AAC9B;IACI,aAAa;IACb,uBAAuB;IACvB,QAAQ;IACR,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,wBAAwB;IACxB,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,QAAQ;IACR,SAAS;IACT,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,0BAA0B;AAC9B;;AAEA,kBAAkB;AAClB;IACI,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,gCAAgC;IAChC,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;AAChB;;AAEA,yCAAyC;AACzC;IACI;QACI,eAAe;IACnB;IACA;QACI,WAAW;QACX,YAAY;IAChB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;IACA;QACI,WAAW;QACX,YAAY;IAChB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;IACA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;IACtB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,cAAc;IAClB;IACA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;IACtB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;AACJ;;AAEA,6BAA6B;AAC7B;IACI;QACI,QAAQ;QACR,sBAAsB;IAC1B;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;QACtB,YAAY;QACZ,mBAAmB;QACnB,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,QAAQ;QACR,2BAA2B;QAC3B,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,gBAAgB;QAChB,SAAS;QACT,uBAAuB;IAC3B;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,SAAO;IACX;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,mCAAmC;QACnC,YAAY;QACZ,mBAAmB;QACnB,gBAAgB;QAChB,eAAe;QACf,6DAA6D;QAC7D,+CAA+C;QAC/C,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,QAAQ;QACR,sBAAsB;IAC1B;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,YAAY;QACZ,mBAAmB;QACnB,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,QAAQ;QACR,2BAA2B;QAC3B,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,gBAAgB;QAChB,SAAS;IACb;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,mBAAmB;QACnB,gBAAgB;QAChB,mCAAmC;QACnC,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,oBAAoB;IACxB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,YAAY;QACZ,mBAAmB;QACnB,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,QAAQ;QACR,2BAA2B;QAC3B,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,QAAQ;QACR,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,mBAAmB;QACnB,gBAAgB;QAChB,mCAAmC;QACnC,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,cAAc;QACd,gBAAgB;IACpB;AACJ;;AAEA,0CAA0C;AAC1C;IACI,aAAa;AACjB;;AAEA;IACI,6CAA6C;AACjD;;AAEA,+CAA+C;AAC/C;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,WAAW;IACX,YAAY;AAChB;;AAEA,mCAAmC;AACnC;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".EmailPassword {\n    color: white;\n    width: 100%;\n    max-width: 100%;\n}\n\n.emailPasswordContainer {\n    display: flex;\n    flex-direction: column;\n    align-items: start;\n    gap: 2px;\n    width: 100%;\n    max-width: 100%;\n}\n\n/* General Input Container Styles */\n.generalInputContainer {\n    display: flex;\n    flex-direction: column;\n    align-items: start;\n    gap: 8px;\n    width: 100%;\n    margin-bottom: 20px;\n}\n\n.labelText {\n    font-family: \"Inter\", sans-serif;\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 24px;\n    color: white;\n}\n\n.inputContainerWrapper {\n    position: relative;\n    background-color: #1a1a1a;\n    width: 31.51vw;\n    height: 4.8vh;\n    border-radius: 52px;\n    box-sizing: border-box;\n    padding-left: 16px;\n    padding-right: 50px;\n    font-family: \"Inter\", sans-serif;\n    font-size: 16px;\n    font-weight: 500;\n    display: flex;\n    align-items: center;\n}\n\n.input {\n    all: unset;\n    width: 100%;\n    height: 100%;\n    color: white;\n    font-family: \"Inter\", sans-serif;\n    font-size: 16px;\n    font-weight: 500;\n}\n\n.input::placeholder {\n    color: #7A7A7A;\n    opacity: 1;\n}\n\n/* Eye icon for password visibility toggle */\n.eyeIcon {\n    position: absolute;\n    right: 16px;\n    top: 50%;\n    transform: translateY(-50%);\n    background: none;\n    border: none;\n    color: #7A7A7A;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 24px;\n    height: 24px;\n    transition: color 0.2s ease;\n    z-index: 10;\n}\n\n.eyeIcon:hover {\n    color: #00c9a7;\n}\n\n.eyeIcon svg {\n    width: 20px;\n    height: 20px;\n}\n\n/* Error tooltip styles */\n.errorTooltip {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    right: 0;\n    padding: 6px 12px;\n    border-radius: 4px;\n    font-size: 12px;\n    font-weight: 400;\n    margin-top: 4px;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    transition: all 0.3s ease;\n    z-index: 10;\n    background: #ff4444;\n    color: white;\n    font-family: \"Inter\", sans-serif;\n}\n\n/* Checkbox container styles */\n.checkboxContainer {\n    display: flex;\n    align-items: flex-start;\n    gap: 8px;\n    margin-top: 20px;\n    width: 100%;\n}\n\n.checkboxContainer input[type=\"checkbox\"] {\n    appearance: none;\n    -webkit-appearance: none;\n    width: 18px;\n    height: 18px;\n    border: 2px solid #ccc;\n    border-radius: 4px;\n    cursor: pointer;\n    position: relative;\n    transition: all 0.2s ease;\n    flex-shrink: 0;\n    margin-top: 2px;\n}\n\n.checkboxContainer input[type=\"checkbox\"]:checked {\n    background-color: #00c9a7;\n    border-color: #00c9a7;\n}\n\n.checkboxContainer input[type=\"checkbox\"]:checked::after {\n    content: \"✓\";\n    position: absolute;\n    color: white;\n    font-size: 14px;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n}\n\n.checkboxLabel {\n    font-family: \"Inter\", sans-serif;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 24px;\n    cursor: pointer;\n    flex: 1;\n    color: white;\n}\n\n.irregularText {\n    color: #00c9a7;\n    cursor: pointer;\n    text-decoration: underline;\n}\n\n/* Button styles */\n.btnContainer {\n    all: unset;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 31.51vw;\n    height: 4.8vh;\n    background-color: #48d1cc;\n    border-radius: 30px;\n    margin-top: 28px;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    font-family: \"Inter\", sans-serif;\n}\n\n.btnContainer:active {\n    transform: translateY(0);\n}\n\n.btnContainer:disabled {\n    background-color: #666;\n    cursor: not-allowed;\n    transform: none;\n}\n\n.btnText {\n    all: unset;\n    font-family: \"Inter\", sans-serif;\n    font-size: 16px;\n    line-height: 24px;\n    font-weight: 500;\n    color: white;\n}\n\n/* Tablet and small desktop adjustments */\n@media (max-width: 1640px) {\n    .checkboxLabel {\n        font-size: 14px;\n    }\n    .checkboxContainer input[type=\"checkbox\"] {\n        width: 16px;\n        height: 16px;\n    }\n    .labelText {\n        font-size: 13px;\n    }\n    .input {\n        font-size: 15px;\n    }\n}\n\n@media (max-width: 1440px) {\n    .checkboxLabel {\n        font-size: 12px;\n    }\n    .checkboxContainer input[type=\"checkbox\"] {\n        width: 14px;\n        height: 14px;\n    }\n    .labelText {\n        font-size: 12px;\n    }\n    .input {\n        font-size: 14px;\n    }\n}\n\n@media (max-width: 1280px) {\n    .checkboxLabel {\n        font-size: 10px;\n    }\n    .checkboxContainer input[type=\"checkbox\"] {\n        width: 12px;\n        height: 12px;\n        border-radius: 3px;\n    }\n    .labelText {\n        font-size: 11px;\n    }\n    .input {\n        font-size: 13px;\n    }\n}\n\n@media (max-width: 1024px) {\n    .checkboxLabel {\n        font-size: 8px;\n    }\n    .checkboxContainer input[type=\"checkbox\"] {\n        width: 10px;\n        height: 10px;\n        border-radius: 3px;\n    }\n    .labelText {\n        font-size: 10px;\n    }\n    .input {\n        font-size: 12px;\n    }\n}\n\n/* Mobile responsive styles */\n@media (max-width: 768px) {\n    .emailPasswordContainer {\n        gap: 8px;\n        padding: 0 16px 0 16px;\n    }\n    \n    .generalInputContainer {\n        margin-bottom: 16px;\n    }\n    \n    .inputContainerWrapper {\n        width: 100% !important;\n        height: 52px;\n        border-radius: 14px;\n        padding-left: 16px;\n        padding-right: 50px;\n    }\n    \n    .input {\n        font-size: 16px;\n    }\n    \n    .labelText {\n        font-size: 14px;\n        font-weight: 500;\n    }\n    \n    .eyeIcon {\n        right: 16px;\n        top: 50%;\n        transform: translateY(-50%);\n        width: 24px;\n        height: 24px;\n    }\n    \n    .eyeIcon svg {\n        width: 22px;\n        height: 22px;\n    }\n    \n    .checkboxContainer {\n        margin-top: 16px;\n        gap: 12px;\n        align-items: flex-start;\n    }\n    \n    .checkboxContainer input[type=\"checkbox\"] {\n        width: 20px;\n        height: 20px;\n        border-radius: 4px;\n        margin-top: 0;\n    }\n    \n    .checkboxContainer input[type=\"checkbox\"]:checked::after {\n        font-size: 16px;\n    }\n    \n    .checkboxLabel {\n        font-size: 14px;\n        line-height: 20px;\n        flex: 1;\n    }\n    \n    .irregularText {\n        font-size: 14px;\n    }\n    \n    .btnContainer {\n        width: calc(100% - 32px) !important;\n        height: 52px;\n        border-radius: 14px;\n        margin-top: 24px;\n        font-size: 16px;\n        background: linear-gradient(135deg, #48d1cc 0%, #3bb5a8 100%);\n        box-shadow: 0 8px 20px rgba(59, 181, 168, 0.25);\n        margin-left: auto;\n        margin-right: auto;\n    }\n    \n    .btnText {\n        font-size: 16px;\n        font-weight: 600;\n    }\n    \n    .errorTooltip {\n        font-size: 11px;\n        padding: 4px 8px;\n    }\n}\n\n@media (max-width: 480px) {\n    .emailPasswordContainer {\n        gap: 8px;\n        padding: 0 12px 0 12px;\n    }\n    \n    .generalInputContainer {\n        margin-bottom: 14px;\n    }\n    \n    .inputContainerWrapper {\n        height: 48px;\n        border-radius: 12px;\n        padding-left: 14px;\n        padding-right: 45px;\n    }\n    \n    .input {\n        font-size: 15px;\n    }\n    \n    .labelText {\n        font-size: 13px;\n    }\n    \n    .eyeIcon {\n        right: 14px;\n        top: 50%;\n        transform: translateY(-50%);\n        width: 20px;\n        height: 20px;\n    }\n    \n    .eyeIcon svg {\n        width: 20px;\n        height: 20px;\n    }\n    \n    .checkboxContainer {\n        margin-top: 14px;\n        gap: 10px;\n    }\n    \n    .checkboxContainer input[type=\"checkbox\"] {\n        width: 18px;\n        height: 18px;\n    }\n    \n    .checkboxContainer input[type=\"checkbox\"]:checked::after {\n        font-size: 14px;\n    }\n    \n    .checkboxLabel {\n        font-size: 13px;\n        line-height: 18px;\n    }\n    \n    .irregularText {\n        font-size: 13px;\n    }\n    \n    .btnContainer {\n        height: 48px;\n        border-radius: 12px;\n        margin-top: 20px;\n        width: calc(100% - 24px) !important;\n        margin-left: auto;\n        margin-right: auto;\n    }\n    \n    .btnText {\n        font-size: 15px;\n        font-weight: 600;\n    }\n    \n    .errorTooltip {\n        font-size: 10px;\n        padding: 3px 6px;\n    }\n}\n\n@media (max-width: 360px) {\n    .emailPasswordContainer {\n        padding: 0 8px 0 8px;\n    }\n    \n    .generalInputContainer {\n        margin-bottom: 12px;\n    }\n    \n    .inputContainerWrapper {\n        height: 44px;\n        border-radius: 10px;\n        padding-left: 12px;\n        padding-right: 40px;\n    }\n    \n    .input {\n        font-size: 14px;\n    }\n    \n    .labelText {\n        font-size: 12px;\n    }\n    \n    .eyeIcon {\n        right: 12px;\n        top: 50%;\n        transform: translateY(-50%);\n        width: 18px;\n        height: 18px;\n    }\n    \n    .eyeIcon svg {\n        width: 18px;\n        height: 18px;\n    }\n    \n    .checkboxContainer {\n        gap: 8px;\n        margin-top: 12px;\n    }\n    \n    .checkboxContainer input[type=\"checkbox\"] {\n        width: 16px;\n        height: 16px;\n    }\n    \n    .checkboxContainer input[type=\"checkbox\"]:checked::after {\n        font-size: 12px;\n    }\n    \n    .checkboxLabel {\n        font-size: 12px;\n        line-height: 16px;\n    }\n    \n    .irregularText {\n        font-size: 12px;\n    }\n    \n    .btnContainer {\n        height: 44px;\n        border-radius: 10px;\n        margin-top: 16px;\n        width: calc(100% - 16px) !important;\n        margin-left: auto;\n        margin-right: auto;\n    }\n    \n    .btnText {\n        font-size: 14px;\n        font-weight: 600;\n    }\n    \n    .errorTooltip {\n        font-size: 9px;\n        padding: 2px 4px;\n    }\n}\n\n/* Focus states for better accessibility */\n.input:focus {\n    outline: none;\n}\n\n.inputContainerWrapper:focus-within {\n    box-shadow: 0 0 0 2px rgba(72, 209, 204, 0.3);\n}\n\n/* Loading state for referral code validation */\n.inputContainerWrapper .loader {\n    position: absolute;\n    right: 16px;\n    top: 50%;\n    transform: translateY(-50%);\n    width: 20px;\n    height: 20px;\n}\n\n/* Success state for valid inputs */\n.inputContainerWrapper.valid {\n    border: 1px solid #00c9a7;\n}\n\n.inputContainerWrapper.error {\n    border: 1px solid #ff4444;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
